/**
 * State used in rendering OverlayDrawer
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
